// src/utils/disableConsole.js

if (window.location.hostname !== "localhost") {
  // List of console methods you wanna block
  ["log", "warn", "error", "info", "debug"].forEach((method) => {
    console[method] = () => {};
  });
}
